import { useMutation } from 'react-query';

import { deleteReportTags as mutationFn } from 'api/endPoints/deleteReportTag/index';

export const useMutationDeleteReportTag = () => {
    return useMutation<string, QueryError, QueryParam>({
        mutationFn: (params) => mutationFn(params),
    });
};

export type QueryParam = number[];
